<template>
  <div class="comment-warning">
    <div
        class="comment-warp"
        :class="{'comment-top-padding': ind > 0}"
        v-for="(val,ind) in dataList"
        :key="ind">

      <div v-for="(item,index) in val.reviewList" :key="`${index}a`" class="flex">
        <img :src="item.imageUrl" class="comment-img"/>
        <div class="comment-right">
          <gj-tooltip :content="item.title | defaultShow ">
          <div class="text-ellipsis-1 comment-title">{{ item.title | defaultShow }}</div>
          </gj-tooltip>
          <ul class="flex">
            <li>
              <span>ASIN</span>
              <gj-link :href="item.asinUrl" target="_blank">{{ item.asin | defaultShow }}</gj-link>
              <span style="display: inline-block; width: 10px">
                <gj-copy-icon class="icon-show" v-if="item.asin" :content="item.asin"></gj-copy-icon>
              </span>
            <li>
              <span>MSKU</span>{{ item.msku | defaultShow }}
              <gj-copy-icon class="icon-show" v-if="item.msku" :content="item.msku"></gj-copy-icon>
            </li>
          </ul>
        </div>
      </div>

      <div class="comment-inner">
        <ul class="flex">
          <li><span>{{ warnTitleCode === 'NEGATIVE_RATINGS_WARN_001' ? 'Review ID' : 'Feedback ID' }}</span>
            {{ warnTitleCode === 'NEGATIVE_RATINGS_WARN_001' ? val.reviewId : val.feedbackId }}
          </li>

          <li v-if="warnTitleCode === 'NEGATIVE_RATINGS_WARN_002'"><span>订单编号</span>{{ val.orderId | defaultShow }}</li>

          <li v-if="val.hasVP && warnTitleCode === 'NEGATIVE_RATINGS_WARN_001'">
            <gj-tag type="plain" color="#1F6EEF">VP</gj-tag>
          </li>

          <li v-if="warnTitleCode === 'NEGATIVE_RATINGS_WARN_001'" class="comment-user flex">
            <span>留评用户</span>
            <span class="text-ellipsis-1">{{ val.reviewUser | defaultShow }}</span>
          </li>

          <li><span>星级数</span>{{ val.star | defaultShow }}</li>

          <li><span>留评时间</span>{{ val.reviewTime | defaultShow }}</li>

          <li>
            <gj-button
                @click="queryDetails(warnTitleCode === 'NEGATIVE_RATINGS_WARN_001'? val.reviewId : val.feedbackId)"
                type="text"
                class="details-btn">查看详情>>
            </gj-button>
          </li>

        </ul>

        <div class="comment-content flex flex-between" ref="comment">
          <span class="content-inner" :class="{'text-ellipsis-1': !val.isOpen && val.isShowTitle}">
             {{ val.reviewContent | defaultShow }}
          </span>

          <div class="flex-btn">
            <gj-button type="text" v-if="val.isShowTitle" @click="changeStatus(val)" class="operator-status">
              {{ val.isOpen ? '收起评论' : '展开评论' }}
              <i :class="val.isOpen?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </gj-button>
          </div>
        </div>
      </div>

      <div class="flex flex-direction-column" v-if="warnTitleCode === 'NEGATIVE_RATINGS_WARN_001'">
          <div class="gj-mtb12 size12">
            <span class="weight600">匹配订单推荐列表</span>
            <span class="color999" style="margin-left: 16px;">同一订单编号若NF邮件中任务已存在，则不会生成NR邮件任务</span>
          </div>
          <gj-table
            :ref="'gjTable'+ind"
            name="recommendTable"
            :data="val.recommendOrderTableData"
            :columns="recommendOrderColumns"
            :index="false"
            :adapt-height="false"
            :isMinHeight="true">
            <template v-slot:orderId="{row}">
              <gj-button type="text" :loading="row.singleLoading" v-if="$permission('order:view')&&isMeaningful(row.orderId)" @click="lookOrder(row)">{{row.orderId | defaultShow}}</gj-button>
              <gj-copy-icon v-if="!$permission('order:view')&&isMeaningful(row.orderId)" :content="row.orderId"/>
            </template>
            <template v-slot:matchResult="{row}">
               <span style="color: red" v-if="row.matchResult === '错误'">{{row.matchResult}}</span>
               <span v-else>{{row.matchResult}}</span>
            </template>
            <template v-slot:buyerName="{row}">
              <div v-if="row.nameType === 'buyerName'">
                <div v-html="row.splitBuyerName"></div>
              </div>
              <div v-else>
                {{ row.buyerName }}
              </div>
            </template>
            <template v-slot:addressName="{row}">
              <div v-if="row.nameType === 'addressName'">
                <div v-html="row.splitAddressName"></div>
              </div>
              <div v-else>
                {{ row.addressName }}
              </div>
            </template>

            <template v-slot:op="{row}">
              <gj-button-group type="dropdown-op">
                <gj-button type="text" v-if="row.status==='waiting'||row.status==='processing'||row.status==='finished'" :loading="row.singleLoading" @click="lookEmail(row.reviewRelateOrderId,row, val, ind)">查看邮件</gj-button>
                <gj-button type="text" v-if="row.status==='nothing'" @click="singleHandle('1',row,'生成邮件', val, ind)" :loading="row.singleLoading">生成邮件</gj-button>
                <gj-button type="text" v-if="row.status==='nothing'" @click="singleHandle('2',row,'删除', val, ind)">删除</gj-button>
                <gj-button type="text" v-if="row.status==='waiting'" @click="singleHandle('3',row,'关闭', val, ind)">关闭</gj-button>
                <gj-button type="text" v-if="row.status==='closed'" @click="singleHandle('4',row,'开启邮件', val, ind)" :loading="row.singleLoading">开启邮件</gj-button>
                <gj-button type="text" v-if="row.status==='processing'" @click="singleHandle('5',row,'标记处理', val, ind)">标记处理</gj-button>
              </gj-button-group>
            </template>
          </gj-table>
      </div>
      <div class="comment-inner gj-mt10" v-if="warnTitleCode === 'NEGATIVE_RATINGS_WARN_002'">
        <gj-button type="primary" @click="feedbackLookEmail(val)">处理此差评</gj-button>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {isMeaningfulMixin} from "@/minxins";
import { singleOperationEmail, getMatchOrderList } from "@/api/sale"; // 列表
import { getMailList, getEmailAccountCombobox } from "@/api/crm"; // 获取邮件
import MailModal from "@/views/modules/sale/review/modal/mail-modal";
import SaleOrderDetail from '@/views/modules/sale/saleOrder/modal/sale-order-detail';

export default {
  name: "comment-warning",
  mixins: [isMeaningfulMixin],
  props: {
    data: {
      type: [Array, Object],
      default: null
    },
    warnTitleCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dataList: [],
      recommendOrderColumns: [
        {id: 'marketId', header: '店铺', field: 'option:marketId', options: () => this.marketOption, minWidth: '100px', default: true},
        {id: 'orderId', header: '订单编号', field: 'slot:orderId', minWidth: '120px', default: true},
        {id: 'matchResult', header: '匹配结果', field: 'slot:matchResult', minWidth: '100px', copyable: true, default: true},
        {id: 'matchType', header: '匹配方式', field: 'matchType', minWidth: '90px', default: true},
        {id: 'buyerName', header: '买家姓名', field: 'slot:buyerName', minWidth: '120px', default: true},
        {id: 'addressName', header: '收货人姓名', field: 'slot:addressName', minWidth: '120px', default: true},
        {id: 'buyerEmail', header: '买家邮箱', field: 'buyerEmail', minWidth: '220px', default: true},
        {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', minWidth: '110px', default: true},
        {id: 'statusName', header: '状态', field: 'statusName', minWidth: '80px', default: true},
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '135px', default: true, notCustomColumn: true}
      ],
      reviewDetailStatusOption: [
        {id: 'nothing', text: '-'},
        {id: 'waiting', text: '待处理'},
        {id: 'processing', text: '处理中'},
        {id: 'finished', text: '已完成'},
        {id: 'closed', text: '已关闭'},
      ]
    }
  },

  computed: {
    ...mapGetters({
      marketOption: 'marketOption',
      markets: 'authMarkets',
    }),
  },

  created() {
    // 格式化数据
    this.dataList = this.data.map(item => {
      if(this.isMeaningful(item.reviewTime)) {
        item.reviewTime = item.reviewTime.split(' ')[0]
      }
      return {...item, isShowTitle: false, isOpen: false}
    })
    if(this.warnTitleCode === 'NEGATIVE_RATINGS_WARN_001') {
      this.dataList.forEach((item, index) => {
        item.recommendOrderTableData = []
        if(this.isMeaningful(item.reviewId)) {
          this.reviewDetailOrder(item, index)
        }
      })
    }
    getEmailAccountCombobox().then(res=>{
      //邮箱--对应店铺列表
      this.marketOptions = this.markets.map(m => {
        let r = res.filter(r => r.marketId === m.id)[0];
        if (r) {
          return {
            mailId:r.id,
            ...r,
            ...m,
            status:r.status
          }
        }else {
          return m
        }
      });
    })
  },

  mounted() {

    this.$nextTick(() => {
      this.$refs.comment.forEach((dom, index) => {
        // 大于一行时，显示展开或收起
        if (dom.offsetHeight > 20) {
          this.dataList[index].isShowTitle = true;
        }
      })
    })
  },

  methods: {
    changeStatus(val) {
      val.isOpen = !val.isOpen;
    },
    queryDetails(id) {
      window.sessionStorage.setItem('commentId', id);

      // review
      if (this.warnTitleCode === 'NEGATIVE_RATINGS_WARN_001') {
        this.$router.push('/sale/review')
      } else {
        //  feedback
        this.$router.push('/sale/feedback');
      }
    },
    // 查询订单列表
    reviewDetailOrder(item, index) {
      item.recommendOrder = true;
      getMatchOrderList(item.reviewId)
          .then(data => {
            data.forEach(items => {
              items.singleLoading = false;//单项操作按钮loading状态
              if (items.matchOriginName) {
                if (items.nameType === "buyerName" && items.buyerName) {
                  items.splitBuyerName = this.matchReplaceName(items, 'buyerName');
                } else if (items.nameType === "addressName") {
                  items.splitAddressName = this.matchReplaceName(items, 'addressName');
                }
              }
            })
            item.recommendOrderTableData = data;
            this.$set(this.dataList, index, this.dataList[index])
          }).complete(() => item.recommendOrder = false);
    },
    // 匹配 名称 变色
    matchReplaceName(item, key) {
      let matchOriginName = item.matchOriginName.toLowerCase();
      if (item.workType === 'exact') {   // 精准匹配
        return `<span style="color:#1F6EEF;background: #EDF7FF;padding: 4px 1px;">${item[key]}</span>`;
      } else if (item.workType === 'word') {
        //  单词匹配
        let woldArr = item[key].split(' ').map(item=> item.toLowerCase()); // 找到第几个单词
        let findArr = woldArr.indexOf(matchOriginName.toLowerCase())
        if(findArr !== -1){
           let num = woldArr.slice(0, findArr).join('').length;
           return this.replaceToHtml(item[key], matchOriginName, num);
        }
        return this.replaceToHtml(item[key], matchOriginName, null);

      } else if (item.workType === 'wordGroup') {   // 词组匹配
        let nameMatchWordArray = matchOriginName.split(' ');
        let sumStr = '';
        nameMatchWordArray.forEach((word, index) => {
          if (index === 0) {
            sumStr = this.replaceToHtml(item[key], word, null);
          } else {
            sumStr = this.replaceToHtml(sumStr, word, null);
          }
        });
        return sumStr;
      } else if (item.workType === 'wordAndLetterFuzzy' || item.workType === 'wordAndLetter') { // 前置位单词+字母  单词+字母词组匹配
        let nameMatchWordArray = matchOriginName.split(' ');
        let sumStr = '';
        let pointIndex = 0;
        nameMatchWordArray.forEach((word, index) => {
          if (index === 0) {
            sumStr = this.replaceToHtml(item[key], word, null);
            pointIndex = item[key].toLowerCase().indexOf(word) + 73 + word.length; // 找到索引位置 + 拼接的长度
          } else {
            sumStr = this.replaceToHtml(sumStr, word, pointIndex);
            pointIndex = sumStr.toLowerCase().indexOf(word, pointIndex + 73) + word.length; //  顺延 从 已匹配后开始找
          }
        });
        return sumStr;
      }
    },
    // 替换 字符 为 HTML
    replaceToHtml(str, keyword, startIndex) {
      let srtEndIndex = 0, srtStartIndex = 0, newStr = '';
      srtStartIndex = str.toLowerCase().indexOf(keyword, startIndex);  // 开始的索引
      if (srtStartIndex === -1) {
        return str;
      }
      srtEndIndex = str.toLowerCase().indexOf(keyword, startIndex) + keyword.length;  // 结束位置的索引
      newStr = str.substring(0, srtEndIndex) + '</span>' + str.substring(srtEndIndex);
      newStr = newStr.substring(0, srtStartIndex) + '<span style="color:#1F6EEF;background: #EDF7FF;padding: 4px 1px;">' + newStr.substring(srtStartIndex);
      return newStr;
    },
    // 查看订单详情
    lookOrder(row) {
      this.$gjCreate(SaleOrderDetail, {
        props: {
          marketId: row.marketId,
          orderId: row.orderId,
          showBtn: true
        }
      })
    },
    //查看邮件
    lookEmail(reviewRelateOrderId,row, val, ind){
      if(row){
        row.singleLoading = true;
      }

      getMailList({model:{reviewRelateOrderId:reviewRelateOrderId}}).then(res=>{
        res.records[0].uploadAttFiles=[];
        this.$gjCreate(MailModal, {
          mountTo: document.getElementById('gj-base-main'),
          props: {
            emailItem:res.records[0],
            marketOptions:this.marketOptions,
            mailType: 'NR'
          },
          on: {
            close: () => {
              this.reviewDetailOrder(val, ind);
            }
          }
        });
      }).complete(()=>{
        if(row){
          row.singleLoading = false;
        }
      })
    },

    // feedback look Email
    feedbackLookEmail(val){
      this.$gjCreate(MailModal, {
        mountTo: document.getElementById('gj-base-main'),
        props: {
          feedbackItem: val,
          marketOptions:this.marketOptions,
          mailType: 'NF',
          source: 'feedback'
        },
        on: {
          close: () => {}
        }
      });
    },
    //单项操作弹框
    singleHandle(type,row, typeStr,val, index){
      if(type === '1'||type === '4'){
        row.singleLoading = true;
        //生成邮件、开启邮件
        this.opHandle(type, row, val, index)
        return
      }
      let content;
      if(type === '2'){
        content = `是否确定删除?`
      }
      else if(type === '3'){
        content = `确认关闭，则此条邮件将自动删除，再次生成邮件任务可通过手动生成邮件，确认关闭吗？`
      }
      else if(type === '5'){
        content = `处理中的邮件进行标记处理，邮件状态将变为已完成，确认标记处理吗？<br>
                   <span style="color:#F5222D;">请谨慎使用此功能！！使用前确认邮件无买家回复！！</span>`
      }
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: typeStr+'提示',
          content: content
        },
        on: {
          confirm: () => {
            this.opHandle(type,row, val, index)
            modal.$gjDestroy()
          },
          cancel: () => {
            modal.$gjDestroy()
          }
        }
      });
    },
    //单项操作
    opHandle(type,row, val, index){
      singleOperationEmail(row.reviewRelateOrderId,type).then(res=>{
        this.reviewDetailOrder(val, index);
        this.$gjMessage.success(`${res}`);
      }).complete(()=>{
        if(row){
          row.singleLoading = false
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
.comment-warning {
  height: calc(100% - 31px);
  overflow-y: auto;
  padding-right: 8px;

  .comment-top-padding {
    padding-top: 12px;
  }

  .comment-warp {
    border-bottom: 1px solid #E4E5E6;
    padding-bottom: 12px;
    color: #333;

    .icon-show {
      display: none;
    }

    &:hover {
      .icon-show {
        display: inline-block;
      }
    }

    .comment-img {
      width: 36px;
      height: 29px;
      margin-right: 12px;
      margin-top: 4px;
    }

    .comment-right {
      flex: 1;
      line-height: 20px;
      font-size: 12px;

      .comment-title {
        font-size: 14px;
      }
    }

    ul {
      padding: 0;
      margin: 4px 0;

      > li {
        list-style: none;
        margin-right: 20px;

        /deep/ .gj-tag {
          height: 16px;
          background: #EEF3FE !important;
          box-sizing: border-box;
          line-height: 14px;
          margin-right: 0;
          border-radius: 2px;
          padding: 0 5px;
        }

        > span {
          margin-right: 8px;
          color: #A0A3A9;
        }

        .details-btn {
          padding: 0;
          margin: 0;
          border: none;
          line-height: 20px;
        }

       /deep/ .el-icon-copy-document {
          color: #979797;
          font-size: 12px;
        }
      }
    }

    .comment-inner {
      margin-left: 48px;
      line-height: 20px;
      font-size: 12px;

      .flex-between {
        justify-content: space-between;
      }

      .comment-content {
        color: #666;
        position: relative;

        .flex-btn {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          margin-left: 5px;
        }

        .padding-right {
          margin-right: 100px;
        }

        .operator-status {
          //float: right;
          line-height: 20px;
          padding: 0;
          border: none;
        }
      }

      .comment-user {
        .text-ellipsis-1 {
          max-width: 64px;
          margin-right: 0;
          color: #333;
        }
      }
    }
    .gj-mt10 {
      margin-top: 10px;
    }
    .gj-mtb12 {
      margin-top: 12px;
      margin-bottom: 12px;
    }
  }
  .text-ellipsis-1 {
    word-break: break-all;
  }
}
</style>
